const BASE_URL ='https://sap-integration-app-dot-dbs-prod.nw.r.appspot.com';
// const BASE_URL ='https://sap-integration-app-dot-nimble-equator-282207.nw.r.appspot.com';
// const BASE_URL ='https://e85053efabd2.ngrok-free.app';
export const API_URLS = {
  API_BASE_URL:{BASE_URL},
  VRIFY_TOKEN:`${BASE_URL}/admins/verifyToken`,
  GET_SAP_PRODUCT: `${BASE_URL}/sap_products/getSapProductList`,
  GET_VARIANT_PRODUCT: `${BASE_URL}/bc_products/getVariantProductList`,
  GET_STORES: `${BASE_URL}/bc/get_stores`,
  LOGIN: `${BASE_URL}/admins/login`,
  UPDATE_BC_PRODUCT_STATUS: `${BASE_URL}/bc_products/updateProductStatus`,
  UPDATE_BC_PRODUCT: `${BASE_URL}/bc_products/updateBCProduct`,
  GET_FRONTEND_TABS: `${BASE_URL}/bc/get_fronend_tabs`,
  GET_KIT_PRODUCTS: `${BASE_URL}/kit/getKitProducts`,
  GET_SAMPLE_PRODUCTS: `${BASE_URL}/promotion/getsamplepromotionproducts`,
  GET_CATAGORY_TREE: `${BASE_URL}/bc/get_category_tree`,
  COMPLETE_SYNC:  `${BASE_URL}/bc_products/sync_by_store`,// master bulk
  CREATE_BC_PRODUCT: `${BASE_URL}/bc_products/createBCProduct`,// master bulk
  SYNC_SELECTED_PRODUCT_INV: `${BASE_URL}/bc_products/syncSelectedBCProductsInventory`,// master bulk
  SEARCH_PRODUCT_SAP_SKU: `${BASE_URL}/bc/searchSAPProductSKU`,
  SEARCH_PRODUCT_BC_SKU: `${BASE_URL}/bc/searchProductSKU`,
  GET_ALL_CATAGORY_TREE: `${BASE_URL}/bc/get_All_store_category_tree`,// pending
  GET_ALL_SIMPLE_PRODUCTS:  `${BASE_URL}/bc_products/getSimpleProductList`,
  UPLOAD_TO_GCP_BUCKET: `${BASE_URL}/bc/uploadRemoveImgBucket`,
  UPDATE_BC_BULK_PRODUCT_STATUS: `${BASE_URL}/bc_products/updateBulkProductStatus`,
  SYNC_INVENTODY: `${BASE_URL}/bc_products/syncSelectedBCProductsInventory`,
  SYNC_SAP:`${BASE_URL}/sap_products/sync_SAP_products_api`,
  CREATE_GIFT_PRODUCT: `${BASE_URL}/bc_products/createGIFTProduct`,
  GET_BUNDLE_PRODUCTS: `${BASE_URL}/bc_products/getBundleProductList`,
  UPDATE_ENRICH: `${BASE_URL}/bc_products/updateBulkProduct`,  
  GET_FRONT_END_ATTRIBUTES:`${BASE_URL}/attributes/getFrontendAttributes`,  
  ADD_ATTRIBUTE_VALUE:`${BASE_URL}/attributes/addAttributesValue`,
  UPDATE_ATTRIBUTES: `${BASE_URL}/attributes/updateAttributes`,
  ADD_ATTRIBUTES: `${BASE_URL}/attributes/addAttributes`,
  GET_LOGS: `${BASE_URL}/admins/getlogs`,
  IMPOT_EXCEL: `${BASE_URL}/bc_products/import_bc_products`,
  BULK_PRICE_UPDATE:`${BASE_URL}/bc_products/updateBulkProductPrice`,  
  UPDATE_BC_PRODUCT_SUBSCRIPTION_STATUS: `${BASE_URL}/bc_products/updateSubscriptionStatus`,
  CONVERT_TO_SAMPLE_PROMOTION_PRODUCT: `${BASE_URL}/promotion/convertToSamplePromotionProduct`,
  GET_BLOGS: `${BASE_URL}/api/v1/admin/blogs`,
  GET_BLOG_BY_ID: `${BASE_URL}/api/v1/admin/blogs`,
  DELETE_BLOG: `${BASE_URL}/api/v1/admin/blogs`,
  SYNC_BLOGS: `${BASE_URL}/api/v1/admin/blogs/sync`,
  SYNC_BLOGS_STATUS: `${BASE_URL}/api/v1/admin/blogs/sync/status`,
  GET_NTS_PRODUCTS: `${BASE_URL}/api/v1/admin/products`,
  GET_NTS_PRODUCT_BY_ID: `${BASE_URL}/api/v1/admin/products`,
  TOGGLE_NTS_PRODUCT_ACTIVE: (id) => `${BASE_URL}/api/v1/admin/products/${encodeURIComponent(String(id))}/toggle-active`,
  GET_QUESTIONS: `${BASE_URL}/api/v1/admin/questions`,
  QUESTION_MAX_STEP: `${BASE_URL}/api/v1/admin/questions/max-step`,
  GET_QUESTION_BY_ID: `${BASE_URL}/api/v1/admin/questions`,
  CREATE_QUESTION: `${BASE_URL}/api/v1/admin/questions`,
  UPDATE_QUESTION: `${BASE_URL}/api/v1/admin/questions`,
  DELETE_QUESTION: `${BASE_URL}/api/v1/admin/questions`,
  KEYWORD_POINTS: (blogId) =>`${BASE_URL}/api/v1/admin/blogs/${blogId}/keyword-points`,
  BUCKETS: `${BASE_URL}/api/v1/admin/buckets`,
  PRODUCT_BUCKETS: `${BASE_URL}/api/v1/admin/product-buckets`,
  BAMBUSER_VIDEOS: `${BASE_URL}/api/v1/admin/bambuser-videos`,
  BAMBUSER_VIDEO_BY_ID: (id) =>
    `${BASE_URL}/api/v1/admin/bambuser-videos/${encodeURIComponent(String(id))}`,
  BAMBUSER_VIDEO_HARD_DELETE: (id) =>
    `${BASE_URL}/api/v1/admin/bambuser-videos/${encodeURIComponent(String(id))}/hard`,
  BAMBUSER_VIDEO_MATCH: `${BASE_URL}/api/v1/admin/bambuser-videos/match`,
  BAMBUSER_VIDEO_KP: (videoId) =>
    `${BASE_URL}/api/v1/admin/bambuser-videos/${encodeURIComponent(String(videoId))}/keyword-points`,
  BAMBUSER_VIDEO_KP_BY_ID: (videoId, kpId) =>
    `${BASE_URL}/api/v1/admin/bambuser-videos/${encodeURIComponent(String(videoId))}/keyword-points/${encodeURIComponent(String(kpId))}`,
  PRODUCT_TYPE: `${BASE_URL}/api/v1/admin/product-type`,
  PRODUCT_TYPE_BY_ID: (id) =>
    `${BASE_URL}/api/v1/admin/product-type/${encodeURIComponent(String(id))}`,
  PRODUCT_KP: (variantId) =>
    `${BASE_URL}/api/v1/admin/products/${encodeURIComponent(String(variantId))}/keyword-points`,
  PRODUCT_KP_BY_ID: (variantId, kpId) =>
    `${BASE_URL}/api/v1/admin/products/${encodeURIComponent(String(variantId))}/keyword-points/${encodeURIComponent(String(kpId))}`,
  OPTION_KP: (questionId, optionId) =>
    `${BASE_URL}/api/v1/admin/questions/${encodeURIComponent(String(questionId))}/options/${encodeURIComponent(String(optionId))}/keyword-points`,
  OPTION_KP_BY_ID: (questionId, optionId, kpId) =>
    `${BASE_URL}/api/v1/admin/questions/${encodeURIComponent(String(questionId))}/options/${encodeURIComponent(String(optionId))}/keyword-points/${encodeURIComponent(String(kpId))}`,
  OPTION_KP_BULK: (questionId, optionId) =>
    `${BASE_URL}/api/v1/admin/questions/${encodeURIComponent(String(questionId))}/options/${encodeURIComponent(String(optionId))}/keyword-points/bulk`,
  PRODUCT_KP_BULK: (variantId) =>
    `${BASE_URL}/api/v1/admin/products/${encodeURIComponent(String(variantId))}/keyword-points/bulk`,
  BAMBUSER_VIDEO_KP_BULK: (videoId) =>
    `${BASE_URL}/api/v1/admin/bambuser-videos/${encodeURIComponent(String(videoId))}/keyword-points/bulk`,
  KEYWORD_POINTS_BULK: (blogId) =>
    `${BASE_URL}/api/v1/admin/blogs/${blogId}/keyword-points/bulk`,
  KEYWORD_POINTS_UPSERT: (blogId) =>
    `${BASE_URL}/api/v1/admin/blogs/${blogId}/keyword-points/bulk-upsert`,
  TAGS: `${BASE_URL}/api/v1/admin/tags`,
  TAG_BY_ID: (id) => `${BASE_URL}/api/v1/admin/tags/${encodeURIComponent(String(id))}`,

  // Rec-blogs (admin-curated blogs with keyword points)
  REC_BLOGS: `${BASE_URL}/api/v1/admin/rec-blogs`,
  REC_BLOG_BY_ID: (id) => `${BASE_URL}/api/v1/admin/rec-blogs/${encodeURIComponent(String(id))}`,
  // Single keyword-point update for a rec-blog (new endpoint from backend fix)
  REC_BLOG_KP_UPDATE: (blogId, kpId) =>
    `${BASE_URL}/api/v1/admin/rec-blogs/${encodeURIComponent(String(blogId))}/keyword-points/${encodeURIComponent(String(kpId))}`,

  // Single option update for a question (new endpoint from backend fix)
  OPTION_UPDATE: (questionId, optionId) =>
    `${BASE_URL}/api/v1/admin/questions/${encodeURIComponent(String(questionId))}/options/${encodeURIComponent(String(optionId))}`,
}
export default API_URLS;